import React from 'react'
import Link from 'gatsby-link'

import styled from 'styled-components'

const HeadingLink = styled(Link)`
  color: #ccc;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 1.5rem;
  padding: 1rem 0;

  @media (min-width: 768px) {
    font-size: 4rem;
    padding: 1.5rem 0;
  }
`;

const MainHeading = styled.h1`
  border-bottom: 2px solid primary;
  color: #333;
  margin: 0 1rem;
`;

const SubHeading = styled.h2`
  color: #333;
  margin: 0 1rem;
  text-align: center;
  font-size: 0.8rem;

  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Header = ({ siteTitle }) => (
  <header>
    <MainHeading>
      <HeadingLink to="/">
        {siteTitle}
      </HeadingLink>
    </MainHeading>
    <SubHeading>Ian Willmott - The Bristol Based McTimoney Chiropractor</SubHeading>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js